function paddingBit0(bin: string, length: number): string {
  return bin.length < length ? paddingBit0(`0${bin}`, length) : bin;
}

export default paddingBit0;
